































































import Vue from 'vue'
import { TableOnePlusTwoInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'TableOnePlusTwoInterface',
  props: {
    templateItemData: {
      type: Object as () => TableOnePlusTwoInterface,
      required: true
    }
  },
  methods: {
    cellStyle (color: string): string {
      return 'color:' + color + ';'
    }
  }
})
